import React, { Component } from "react";
import PropTypes from "prop-types";

export class Index extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    children: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    let query = new URLSearchParams(this.props.location.search);
    this.state = {
      steps: [],
      startTour: false,
      page: query.get('page') || 1,
      per_page: query.get('per_page') || "",
      category: query.get('category') || "",
      search: query.get('search') || "",
      sort: "",
      direction: ""
    };
  }

  // ------------------------------------------------------------------------
  // Handle Searching, Pagination, Filtering: Start
  // ------------------------------------------------------------------------

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.search != prevProps.location.search) {
      let query = new URLSearchParams(this.props.location.search);
      this.setState({
          page: query.get('page') || 1,
          per_page: query.get('per_page') || "",
          search: query.get('search') || "",
          category: query.get('category') || "",
          sort: query.get('sort') || "",
          direction: query.get('direction') || ""
        });
    } else if (this.state != prevState) {
      this.fetchData();
    }
  }

  handleOrder(e) {
    let sort = e.target.dataset.sort;
    let direction = "desc";
    let query = new URLSearchParams(this.props.location.search);
    if (sort == query.get('sort')) {
      if (query.get('direction')) {
        if (query.get('direction') == "asc") {
          direction = "desc";
        } else {
          direction = "asc";
        }
      }
    }
    this.setState({ sort: sort, direction: direction });
  }

  handlePagination(page, per_page) {
    this.setState({ page: page, per_page: per_page });
  }

  handleSearch(searchStr) {
    this.setState({ search: searchStr, page: 1, category: "" });
  }

  handleFilterCategory(e) {
    let category_id = e.target.value;
    this.setState({ category: category_id, page: 1, search: "" });
  }

  serialize(obj) {
    return (
      "?" +
      Object.keys(obj)
        .reduce(function(a, k) {
          a.push(k + "=" + encodeURIComponent(obj[k]));
          return a;
        }, [])
        .join("&")
    );
  }

  indicateSorting(field) {
    let query = new URLSearchParams(this.props.location.search);
    let sort = query.get('sort');
    let direction = query.get('direction');
    if (sort == field) {
      return direction;
    }
    return "";
  }

  categoryOptions(categories) {
    let selected = "";
    let selectOptions = categories.map(category => {
      if (parseInt(this.state.category) == category.id) {
        selected = "selected";
      } else {
        selected = "";
      }
      return (
        <option key={category.id} value={category.id} selected={selected}>
          {category.name}
        </option>
      );
    }, this);
    return selectOptions;
  }

  // ------------------------------------------------------------------------
  // Handle Searching, Pagination, Filtering: End
  // ------------------------------------------------------------------------

  tourCallback(data) {
    const { type } = data;
    if (type == "tour:end") {
      this.setState({ startTour: false });
    }
  }

  render() {
    return (
      <div className="index">
        {this.props.children}
      </div>
    );
  }
}

export default Index;
